// eslint-disable-next-line monorepo/forbidden-imports
import type { TopBarConfig } from '@xing-com/top-bar';

import type { ConfigurationItem, Translate } from '../types';

const NAVIGATION_BADGE_NO_BADGE = 'navigation_badge_no_badge';

export const topBar: ConfigurationItem = (t: Translate): TopBarConfig => {
  return [
    // Unfortunately, the required prop hasMessengerAction is coming in from
    // the meta renderer props, so we have to do:
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [
      'TopBarNavItem' as const,
      {
        'data-qa': 'top-bar-icon-messenger',
        tracking: {
          sc_o: 'navigation_messages',
          sc_o_PropActionOrigin: [
            'navigation_badge_messages',
            NAVIGATION_BADGE_NO_BADGE,
          ],
        },
        icon: { $component: 'IconMessages' },
        title: t('VERTICAL_NAVIGATION_MESSAGES'),
        href: '/chats',
        notificationKey: 'unreadChats',
      },
    ] as any,
    [
      'TopBarSearchItem',
      {
        'data-qa': 'top-bar-search',
        icon: { $component: 'IconSearch' },
        size: 'medium',
      },
    ],
  ];
};
